import React, { useState, useEffect } from 'react'
import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material'
import { formatDecimal } from '../../utils/tools'
import styles from './Select.module.scss'

export default function SelectNumber({value, setValue, fieldName, topLimit=9999, netherLimit=1 }) {
  const [localValue, setLocalValue] = useState(value)
  
  // useEffect(() => !isNaN(localValue) && typeof localValue === 'number' && setValue({value: localValue, name: fieldName}) 
  //   ,[localValue]) // eslint-disable-line

  useEffect(() => {setValue({value: localValue, name: fieldName});return () => {}} 
    ,[localValue]) // eslint-disable-line

  const changeValue = e => {
    let newValue = e.target.value || ''
    if([''].includes(newValue)) setLocalValue(newValue)
    else newValue <= topLimit && newValue >= netherLimit && !isNaN(parseInt(newValue)) && setLocalValue(parseInt(newValue))
  }
  

  const down = () => setLocalValue(localValue!=1?Math.max(localValue-1, netherLimit):localValue)
  const up = () => setLocalValue(Math.min(localValue+1, topLimit))
 
  const handleLeaveComponent = () => typeof localValue !== 'number' && setLocalValue(value)
  
  return (
    <>
    <div className={styles['select-number']} onBlur={handleLeaveComponent}>
      <div className={ `${styles['select']} ${styles['input-number']}`}>
          <input style={{ width: "5ch"}} value={localValue} onChange={changeValue}/>
        <div className={styles['input-buttons']}>
          <button onClick={up}><ArrowDropUp/></button>
          <button onClick={down}><ArrowDropDown/></button>
        </div>
      </div>
    </div>
    </>
  )
}